import avatarModule from '../avatarModule';

function orderObjectBy() {
  'ngInject';

  return function(items, field) {
    const filtered = [];
    angular.forEach(items, function(item) {
      filtered.push(item);
    });
    filtered.sort(function(a, b) {
      return a[field] > b[field] ? 1 : -1;
    });
    return filtered;
  };
}

avatarModule.filter('orderObjectBy', orderObjectBy);
